import { auth } from '../firebase/config';

const CREATE_ADMIN_URL = 'https://us-central1-ieum-8fd99.cloudfunctions.net/createAdminUser';
const MANAGE_ADMIN_URL = 'https://us-central1-ieum-8fd99.cloudfunctions.net/adminManageStaffAccount';

const postAdminFunction = async (url, payload) => {
  const currentUser = auth.currentUser;
  if (!currentUser) throw new Error('관리자 로그인이 필요합니다.');

  const token = await currentUser.getIdToken();
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok || !data.ok) {
    const error = new Error(data.error || '직원 계정 처리에 실패했습니다.');
    error.code = data.code || 'admin-account/request-failed';
    error.status = response.status;
    throw error;
  }
  return data;
};

export const createAdminAccount = (payload) => postAdminFunction(CREATE_ADMIN_URL, payload);

export const updateAdminAccountRole = (uid, role) => postAdminFunction(MANAGE_ADMIN_URL, {
  action: 'role',
  uid,
  role,
});

export const updateAdminAccountProfile = (uid, profile) => postAdminFunction(MANAGE_ADMIN_URL, {
  action: 'profile',
  uid,
  ...profile,
});

export const deleteAdminAccount = (uid) => postAdminFunction(MANAGE_ADMIN_URL, {
  action: 'delete',
  uid,
});
